<template>
  <div class="create-general-meeting">
    <el-form :model="basicModel" label-width="100px">
      <el-form-item label="会议类型：" class="my-item" required>
        <el-radio-group v-model="basicModel.meetingType">
          <el-radio :label="1">综合议题会议</el-radio>
          <el-radio :label="2" disabled>其他专题会议</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="会议主题：" required>
        <el-input
          v-model="basicModel.meetingTopic"
          clearable
          maxlength="100"
          show-word-limit
          placeholder="-请输入-"
        ></el-input>
      </el-form-item>
    </el-form>
    <div class="tabs">
      <el-tabs v-model="activeName">
        <!---------------------------------- 选择会议议题 ---------------------------------->
        <el-tab-pane label="会议议题" name="first" disabled>
          <div class="tab-wrapper">
            <el-button
              type="primary"
              @click="selectMeetingBill"
              icon="el-icon-plus"
              >选择议题</el-button
            >
            <el-table
              :data="meetingBillTable"
              border
              style="width: 100%; margin-top: 10px"
            >
              <el-table-column
                type="index"
                width="50"
                label="序号"
              ></el-table-column>
              <el-table-column
                prop="title"
                label="议题"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column
                prop="reportUserName"
                label="汇报人"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column label="参会部门" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span v-for="item in scope.row.checkWorkList" :key="item.id">
                    {{ item.name }} &nbsp;
                  </span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="text"
                    size="mini"
                    @click="removeMeetingBill(scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="tab-wrapper-footer">
              <el-button type="info" @click="cancelCreate">取消</el-button>
              <el-button type="primary" @click="gotoSchedule">下一步</el-button>
            </div>
          </div>
        </el-tab-pane>
        <!---------------------------------- 生成会议议程 ---------------------------------->

        <el-tab-pane label="会议议程" name="second" disabled>
          <div class="tab-wrapper">
            <div>
              <el-button type="primary" @click="createMeetingSchedule"
                >生成议程</el-button
              >
              <span>提示：每次修改会议议题后，需重新生成会议议程</span>
            </div>
            <el-table
              :data="meetingScheduleTable"
              border
              size="mini"
              style="width: 100%; margin-top: 10px"
              :cell-class-name="cellClassHandler"
            >
              <el-table-column
                type="index"
                width="50"
                label="序号"
              ></el-table-column>
              <el-table-column label="主题" show-overflow-tooltip>
                <template slot-scope="scope">
                  <p
                    class="bill-item"
                    v-for="item in scope.row.bills"
                    :key="item.id"
                  >
                    <!-- {{ item.theme || "---" }} -->
                    <el-input
                      :value="item.theme || '---'"
                      @input="
                        (val) =>
                          changeScheduleTheme(val, scope.row.bills, item.id)
                      "
                    ></el-input>
                  </p>
                </template>
              </el-table-column>
              <el-table-column label="议题" show-overflow-tooltip>
                <template slot-scope="scope">
                  <p
                    class="bill-item"
                    v-for="item in scope.row.bills"
                    :key="item.id"
                  >
                    <!-- <el-input
                      :value="item.title || '---'"
                      @input="
                        (val) =>
                          changeScheduleTitle(val, scope.row.bills, item.id)
                      "
                    ></el-input> -->
                    {{ item.title || "---" }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column label="汇报人" show-overflow-tooltip>
                <template slot-scope="scope">
                  <p
                    class="bill-item"
                    v-for="item in scope.row.bills"
                    :key="item.id"
                  >
                    {{ item.reportUserName || "---" }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column label="参会部门" show-overflow-tooltip>
                <template slot-scope="scope">
                  <p
                    v-for="item in scope.row.bills"
                    :key="item.id"
                    class="bill-item"
                  >
                    <span
                      v-for="(dept, index) in item.checkWorkList"
                      :key="index"
                    >
                      {{ dept.name || "---" }} &nbsp;
                    </span>
                  </p>
                </template>
              </el-table-column>
              <el-table-column width="450">
                <template slot="header" slot-scope="scope">
                  <div style="text-align: center">会议类别</div>
                  <div class="checkbox-wrapper">
                    <el-checkbox
                      v-for="(type, index) in meetingTypeList"
                      :key="index"
                      :value="isAllChecked(scope, type)"
                      @change="selectAllChangeHandler(scope, type)"
                      >全选</el-checkbox
                    >
                  </div>
                </template>
                <template slot-scope="scope">
                  <div class="checkbox-wrapper">
                    <el-checkbox
                      v-for="(type, index) in meetingTypeList"
                      :key="index"
                      :value="isTypeChecked(scope.row, type)"
                      @change="checkboxChangeHandler(scope.row, type)"
                      >{{ type.value }}</el-checkbox
                    >
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="400">
                <template slot-scope="scope">
                  <el-button type="text" @click="removeSchedule(scope.row)"
                    >删除</el-button
                  >
                  <el-button type="text" @click="createFile(scope.row)"
                    >生成汇报材料</el-button
                  >
                  <el-button type="text" @click="clickUp(scope.row)"
                    >上移</el-button
                  >
                  <el-button type="text" @click="clickDown(scope.row)"
                    >下移</el-button
                  >
                  <el-button type="text" @click="clickTop(scope.row)"
                    >置顶</el-button
                  >
                  <el-button type="text" @click="clickBottom(scope.row)"
                    >置底</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <div class="tab-wrapper-footer">
              <el-button type="primary" @click="gotoBill">上一步</el-button>
              <el-button type="info" @click="cancelCreate">取消</el-button>
              <el-button type="primary" @click="gotoArrangement"
                >下一步</el-button
              >
            </div>
          </div>
        </el-tab-pane>
        <!--------------------------------- 生成会议安排，显示列表 ---------------------------------->
        <el-tab-pane label="会议安排" name="third" disabled>
          <div class="tab-wrapper">
            <div>
              <el-button type="primary" @click="createArrangement"
                >生成会议安排</el-button
              >
              <span>提示：每次修改会议议程后，需重新生成会议安排</span>
            </div>
            <div class="arrange-list">
              <div
                class="arrange-item"
                v-for="(item, index) in arrangementList"
                :key="index"
              >
                <el-form
                  ref="arrangeFormRef"
                  :model="item.model"
                  label-width="120px"
                >
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="会议类别：" required>
                        <el-input
                          :value="
                            getMeetingTypeName(item.model.meetingTypeLabel)
                          "
                          readonly
                        ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="打印文件标题" required>
                        <el-select
                          v-model="item.model.printTitle"
                          placeholder="-请选择-"
                          style="width: 100%"
                        >
                          <!-- 就神奇 -->
                          <el-option
                            v-for="option in conferencePrintDict"
                            :key="option.value"
                            :label="option.value"
                            :value="option.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="会议时间：" required>
                        <el-date-picker
                          v-model="item.model.meetingTime"
                          type="datetime"
                          placeholder="-请选择-"
                          default-time="9:00:00"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="会议次数">
                        <el-input
                          v-model="item.model.conferNum"
                          placeholder="-请填写-"
                        ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-form-item label="会议地点：" required>
                    <el-input
                      v-model="item.model.meetingRoom"
                      clearable
                      placeholder="-请输入-"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="出席人员：" required>
                    <div class="el-input tag-wrapper">
                      <el-tag
                        v-for="tag in item.model.participanceList"
                        @close="closeParticipance(tag, item)"
                        :key="tag.id"
                        closable
                        style="margin-right: 5px"
                        >{{ tag.displayName || tag.name }}</el-tag
                      >
                    </div>
                    <el-button
                      @click="selectParticipanceList(item, index)"
                      type="primary"
                      >选择</el-button
                    >
                  </el-form-item>
                   <el-form-item label="列席人员：" required>
                    <el-input
                      v-model="item.model.meetingAttendWorkName"
                      clearable
                      placeholder="-请输入-"
                    ></el-input>
                  </el-form-item>
                  <el-form-item label="抄送人员：" required>
                    <div class="el-input tag-wrapper">
                      <el-tag
                        v-for="tag in item.model.ccParticipanceList"
                        @close="closeCcParticipance(tag, item)"
                        :key="tag.id"
                        closable
                        style="margin-right: 5px"
                        >{{ tag.displayName || tag.name }}</el-tag
                      >
                    </div>
                    <el-button
                      @click="selectJoinWorkJsonList(item, index)"
                      type="primary"
                      >选择</el-button
                    >
                  </el-form-item>
                </el-form>
                <el-table
                  border
                  :data="item.list"
                  style="margin-top: 5px; width: 100%"
                >
                  <el-table-column
                    type="index"
                    width="50"
                    label="序号"
                  ></el-table-column>
                  <el-table-column label="主题" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <p
                        v-for="(bill, index) in scope.row.bills"
                        :key="index"
                        class="divider"
                      >
                        <span>{{ bill.theme || "---" }}</span>
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column label="议题" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <p
                        v-for="(bill, index) in scope.row.bills"
                        :key="index"
                        class="divider"
                      >
                        <span>{{ bill.title || "---" }}</span>
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column label="汇报人" show-overflow-tooltip>
                    <template slot-scope="scope">
                      <p
                        v-for="(bill, index) in scope.row.bills"
                        :key="index"
                        class="divider"
                      >
                        <span>{{ bill.reportUserName || "---" }}</span>
                      </p>
                    </template>
                  </el-table-column>
                  <el-table-column label="参会部门">
                    <template slot-scope="scope">
                      <p
                        v-for="(bill, index) in scope.row.bills"
                        :key="index"
                        class="divider"
                      >
                        <span v-for="work in bill.checkWorkList" :key="work.id">
                          {{ work.name || "---" }} &nbsp;
                        </span>
                      </p>
                    </template>
                  </el-table-column>
                </el-table>
                <div style="text-align: center; margin: 10px auto">
                  <el-button type="primary" @click="previewArrangement(item)"
                    >预览安排</el-button
                  >
                </div>
              </div>
            </div>
            <div style="padding: 10px 0 40px; text-align: center">
              <el-button type="primary" @click="backtoSchedule"
                >上一步</el-button
              >
              <el-button type="info" @click="cancelCreate">取消</el-button>
              <el-button type="primary" @click="submitArrangement"
                >保存</el-button
              >
              <el-button type="primary" @click="saveArrangement"
                >暂存</el-button
              >
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <meeting-bill-select-dialog
      :visible="meetingBillSelectDialogVisible"
      @submit="submitMeetingBill"
    />
    <meeting-schedule-dialog
      :visible="meetingScheduleDialogVisible"
      @submit="submitMeetingSchedule"
      :meetingBillList="meetingBillTable"
    />
    <select-dialog
      :visible="selectDialogVisible"
      @close="selectDialogClose"
      title="选择出席人员"
      v-bind="selectDialogOptions"
    />

    <joinWork-dialog
      :visible="JoinWorkJsonDialogVisible"
      @close="ccJoinWorkJsonClose"
      title="选择抄送人员"
      v-bind="ccJoinWorkJsonOptions"
    />
    
    <el-dialog title="会议材料" :visible.sync="textDialogVisible">
      <div :id="editorId"></div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="textDialogVisible = false" type="info"
          >关闭</el-button
        >
        <el-button type="primary" @click="printFile">打印</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="会议安排预览"
      :visible.sync="printArrageVisible"
      width="800px"
    >
      <ArrangeTable :detail="printArrangeDetail" />
      <!-- <div slot="footer">
        <el-button type="info" @click="printArrageVisible = false"
          >关闭</el-button
        >
        <el-button type="primary" @click="doPrintArrangement">打印</el-button>
      </div> -->
    </el-dialog>
  </div>
</template>
<script>
import { editorConfig } from "../editorConfig";
import SelectDialog from "@/page/meeting/bill/SelectDialog";
import joinWorkDialog from "@/page/meeting/bill/SelectDialog";  //抄送人员弹窗
import MeetingBillSelectDialog from "./meetingBillSelectDialog";
import MeetingScheduleDialog from "./meetingScheduleDialog";
import {
  getOtherConferenceTypeList,
  createConferenceDeclaration,
  createConferencePlan,
  getConferenceDetail,
  conferencePrintDictApi,
  conferenceCountApi,
} from "@/services/conferenceServices";
import { getDefaultGroupApi } from "@/services/groupService";
import Constants from "@/utils/consts";
import { getDeclarationDetail } from "@/services/declarationServices";
import ArrangeTable from "./ArrangeTable";
export default {
  name: "CreateGeneralMeeting",
  components: {
    MeetingBillSelectDialog,
    MeetingScheduleDialog,
    SelectDialog,
    joinWorkDialog,
    ArrangeTable,
  },
  data() {
    return {
      printArrangeDetail: null,
      printArrageVisible: false,
      editorId: "create-general-meeting-editor-container" + Date.now(),
      editorConfig,
      myEditor: undefined,
      basicModel: {
        meetingType: 1,
        meetingTopic: "",
      },
      activeName: "first",
      meetingBillTable: [], // 选定的提包单列表
      meetingBillSelectDialogVisible: false,
      meetingTypeList: [], // 会议类型列表
      meetingScheduleTable: [], // 将提报单合并成会议议程
      meetingScheduleDialogVisible: false,
      arrangementList: [], //会议安排
      meetingScheduleId: undefined, // 保存会议议程后，返回的整个的id
      selectDialogVisible: false,
      JoinWorkJsonDialogVisible: false,
      selectDialogOptions: {
        //出席人员选择配置
        departOn: true,
        groupOn: true,
        canSelectDepart: false,
        canSelectUser: true,
        canSelectGroup: true,
        maxSelectedItem: 0,
        dataKey: "",
      },
      ccJoinWorkJsonOptions: {
        //抄送人员选择配置
        departOn: true,
        groupOn: true,
        canSelectDepart: true,
        canSelectUser: true,
        canSelectGroup: true,
        maxSelectedItem: 0,
        dataKey: "",
      },
      textDialogVisible: false,
      arrangeRules: {
        meetingTime: [
          {
            type: "date",
            required: true,
            message: "请选择会议时间",
            trigger: "change",
          },
        ],
        meetingRoom: [
          { required: true, message: "请输入会议地点", trigger: "blur" },
        ],
        meetingAttendWorkName: [
          { required: true, message: "请输入列席人员", trigger: "blur" },
        ],
      },
      defaultGroupInfo: {},
      conferencePrintDict: [],
      conferenceCount: 0,
    };
  },
  beforeDestroy() {
    if (this.myEditor) {
      this.myEditor.dispose();
    }
  },
  methods: {
    previewArrangement(data) {
      // 在创建阶段，可以先打印一下让领导看下行不行。
      console.log("打印的数据", data);
      if (!data) {
        return;
      }


      // 预览安排要填写完整信息
      let { model } = data;
      let { meetingRoom, meetingTime, participanceList, meetingAttendWorkName,printTitle="" } = model;
      if (
        !meetingRoom ||
        !meetingTime ||
        !participanceList ||
        !meetingAttendWorkName||
        participanceList.length == 0 ||
        printTitle == ""
      ) {
        this.$alert("信息填写不完整", "提示");
        return;
      }

      let formatData = {};
      formatData.startTime = data.model.meetingTime;
      formatData.joinWorkJson = JSON.stringify(data.model.participanceList);
      formatData.printTitle = data.model.printTitle;
      formatData.conferNum = data.model.conferNum;
      formatData.room = data.model.meetingRoom;
      formatData.attendWorkName = data.model.meetingAttendWorkName;
      formatData.type = data.model.meetingTypeLabel;
      let target = this.meetingTypeList.find(
        (item) => item.label == formatData.type
      );
      formatData.typeDisplayName = target ? target.value : "";
      // console.log(this.meetingTypeList)
      formatData.agendaList = [];
      for (let i = 0; i < data.list.length; i++) {
        let declarationList = JSON.parse(
          JSON.stringify(data.list[i].bills || [])
        );
        let title = "";
        declarationList.forEach((item) => {
          item.checkWorkJson = JSON.stringify(item.checkWorkList || []);
          title += item.theme + "\n";
        });
        formatData.agendaList.push({
          title: title,
          declarationList: declarationList,
        });
      }

      console.log("format data", formatData);
      this.$set(this, "printArrangeDetail", formatData);
      this.printArrageVisible = true;
    },
    // doPrintArrangement() {
    //   try {
    //     let selector = ".print-table-wrapper";
    //     let container = $(selector);
    //     container.printArea();
    //   } catch (error) {
    //     console.log(error);
    //   }
    // },
    getConferenceCount() {
      conferenceCountApi()
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.conferenceCount = res.data;
          } else {
            this.conferenceCount = 0;
          }
        })
        .catch(() => {});
    },
    //----修改议程主题------
    changeScheduleTheme(val, bills, id) {
      let target = bills.find((item) => item.id == id);
      if (target) {
        target.theme = val;
      }
    },
    changeScheduleTitle(val, bills, id) {
      let target = bills.find((item) => item.id == id);
      if (target) {
        target.title = val;
      }
    },
    //------------------

    // ----移动议程--------

    clickUp(record) {
      let index = this.meetingScheduleTable.findIndex((item) => item == record);
      console.log("===>index", index);
      if (index == -1) {
        return;
      }
      if (index != 0) {
        let data = [...this.meetingScheduleTable];
        let upData = data[index - 1];
        data[index - 1] = data[index];
        data[index] = upData;
        this.meetingScheduleTable = data;
      }
    },
    clickDown(record) {
      let index = this.meetingScheduleTable.findIndex((item) => item == record);
      if (index == -1) {
        return;
      }
      if (index != this.meetingScheduleTable.length - 1) {
        let data = [...this.meetingScheduleTable];
        let downData = data[index + 1];
        data[index + 1] = data[index];
        data[index] = downData;
        this.meetingScheduleTable = data;
      }
    },
    clickTop(record) {
      let index = this.meetingScheduleTable.findIndex((item) => item == record);
      if (index == -1) {
        return;
      }
      if (index != 0) {
        let data = [...this.meetingScheduleTable];
        let topData = data[0];
        data[0] = data[index];
        data[index] = topData;
        this.meetingScheduleTable = data;
      }
    },
    clickBottom(record) {
      let index = this.meetingScheduleTable.findIndex((item) => item == record);
      if (index == -1) {
        return;
      }
      if (index != this.meetingScheduleTable.length - 1) {
        let data = [...this.meetingScheduleTable];
        let bottomData = data[this.meetingScheduleTable.length - 1];
        data[this.meetingScheduleTable.length - 1] = data[index];
        data[index] = bottomData;
        this.meetingScheduleTable = data;
      }
    },
    //--------------------
    printFile() {
      if (this.myEditor) {
        this.myEditor.execCommand("print");
      }
    },
    createFile(row) {
      console.log("...", row);
      const { selectedTypes, bills } = row;
      if (!selectedTypes || selectedTypes.length == 0) {
        this.$alert("请先选定会议类别", "提示");
        return;
      }
      let types = [];
      selectedTypes.forEach((t) => {
        types.push(t.value);
      });
      // let h1 = types.join("暨"); // 标题
      let h1 = "青岛路桥建设集团有限公司";
      let promiseList = bills.map((item) => {
        return new Promise((resolve, reject) => {
          // 数据可能不全
          getDeclarationDetail({ id: item.id }).then((res) => {
            if (res.code == Constants.Code_OK) {
              resolve(res.data);
            } else {
              reject(new Error(res.msg));
            }
          });
        });
      });
      Promise.all(promiseList)
        .then((result) => {
          let main = [];
          let files = [];
          for (let i = 0; i < result.length; i++) {
            let item = result[i];
            let { title, declarationItemsVOs, content } = item;
            let titleStr = `<h2 style="text-align: center;">${title}</h2>`;
            let contentStr = `<p>${content}</p>`;
            let part = `${titleStr}<p><br></p>${contentStr}<p><br></p>`;
            main.push(part);

            if (declarationItemsVOs) {
              declarationItemsVOs.forEach((o) => {
                files.push(`<li><p>${o.name}</p></li>`);
              });
            }
          }

          let head = `<h4 style="text-align: right;margin-right: 50px;">会后收回</h4>`;
          head += `<h1 style="text-align: center;"><span style="color: rgb(240, 102, 102);">${h1}会议材料</span></h1>`;
          head += `<h4 style="text-align: right;margin-right: 200px;">签批：</h4>`;
          head += `<h4 style="text-align: right;margin-right: 200px;">审核：</h4>`;
          head += `<hr/>`;

          let body = main.join("");
          let footer = files.join("");
          if (footer) {
            footer =
              "<h3>附件:</h3><p><br></p>" +
              '<ol class=" list-paddingleft-2" style="list-style-type: decimal;">' +
              footer +
              "</ol>";
          }
          let content = `${head}<p><br></p>${body}<p><br></p>${footer}<p><br></p>`;
          this.textDialogVisible = true;
          this.$nextTick(() => {
            // this.$refs.textEditor.content = content;
            if (!this.myEditor) {
              this.myEditor = window.UE.getEditor(
                // "create-general-meeting-editor-container",
                this.editorId,
                this.editorConfig
              );
            }
            const editor = this.myEditor;
            editor.ready(function () {
              editor.setContent(content);
            });
          });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    cellClassHandler({ row, column, rowIndex, columnIndex }) {
      // if (columnIndex == 1) {
      //   // 主题
      //   return "no-padding-column";
      // }
      // if (columnIndex == 2) {
      //   // 议题
      //   return "no-padding-column";
      // }
      // if (columnIndex == 3) {
      //   // 汇报人
      //   return "no-padding-column";
      // }
      // if (columnIndex == 4) {
      //   // 参会部门
      //   return "no-padding-column";
      // }
      return "";
    },
    formatReportUser(row) {
      // 去掉重复显示
      const { bills } = row;
      let result = new Set();
      bills.forEach((b) => {
        result.add(b.reportUserName);
      });
      return Array.from(result);
    },
    onActive() {
      this.activeName = "first";
      this.initConferenceTypeList();
      this.getDefaultGroup();
      this.getConferenceDict();
      this.getConferenceCount();
    },
    /**
     * 获取打印文件标题
     */
    getConferenceDict() {
      conferencePrintDictApi()
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.conferencePrintDict = res.data || [];
          } else {
            this.conferencePrintDict = [];
          }
        })
        .catch((error) => {
          this.conferencePrintDict = [];
        });
    },
    getDefaultGroup() {
      let orgId = sessionStorage.getItem("orgId");
      getDefaultGroupApi({
        orgId,
      })
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            console.log("默认群组", res.data);
            this.defaultGroupInfo = res.data;
          }
        })
        .catch(() => {});
    },
    selectParticipanceList(item, index) {
      // 选择出席人员
      this.selectDialogOptions.dataKey = `${index}`;
      this.selectDialogVisible = true;
    },
    selectJoinWorkJsonList(item, index) {
      // 选择抄送人员
      this.ccJoinWorkJsonOptions.dataKey = `${index}`;
      this.JoinWorkJsonDialogVisible = true;
    },
    closeParticipance(tag, item) {
      try {
        let index = item.model.participanceList.findIndex(
          (comp) => comp == tag
        );
        console.log("close idnex", index);
        if (index != -1) {
          item.model.participanceList.splice(index, 1);
        }
      } catch (error) {
        console.log(error);
      }
    },
    closeCcParticipance(tag, item) {
      try {
        let index = item.model.ccParticipanceList.findIndex(
          (comp) => comp == tag
        );
        console.log("close idnex", index);
        if (index != -1) {
          item.model.ccParticipanceList.splice(index, 1);
        }
      } catch (error) {
        console.log(error);
      }
    },
    selectDialogClose(data) {
      this.selectDialogVisible = false;
      let { dataKey } = data;
      dataKey = parseInt(dataKey);
      let target = this.arrangementList[dataKey];
      console.log("--selectDialogClose target", target);
      let participanceList = target.model.participanceList;
      let userList = data.userList || [];
      let groupList = data.groupList || [];
      userList.forEach((user) => {
        user.meetingType = "user";
      });
      groupList.forEach((group) => {
        group.meetingType = "group";
      });
      let list = userList.concat(groupList);
      list.forEach((item) => {
        let index = participanceList.findIndex(
          (ele) => item.meetingType == ele.meetingType && item.id == ele.id
        );
        if (index == -1) {
          participanceList.push(item);
        }
      });
    },
    ccJoinWorkJsonClose(data) {
      this.JoinWorkJsonDialogVisible = false;
      let { dataKey } = data;
      dataKey = parseInt(dataKey);
      let target = this.arrangementList[dataKey];
      let ccParticipanceList = target.model.ccParticipanceList;
      let userList = data.userList || [];
      let groupList = data.groupList || [];
      let departList = data.departList || [];
      userList.forEach((user) => {
        user.meetingType = "user";
      });
      groupList.forEach((group) => {
        group.meetingType = "group";
      });
      departList.forEach((dept) => {
        dept.meetingType = "dept";
      });
      let list = userList.concat(groupList).concat(departList);
      list.forEach((item) => {
        let index = ccParticipanceList.findIndex(
          (ele) => item.meetingType == ele.meetingType && item.id == ele.id
        );
        if (index == -1) {
          ccParticipanceList.push(item);
        }
      });
    },
    initConferenceTypeList() {
      getOtherConferenceTypeList()
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            let list = res.data || [];
            list.forEach((item) => {
              // 几个类型值对应的全选checkbox是否被选中
              item.allSelectedCheck = false;
            });
            let filterList = list.filter((item) => item.label != "zthy");
            // 创建综合会议时，会议类型里没有专题会议
            this.meetingTypeList = filterList;
          }
        })
        .catch((error) => {});
    },
    gotoSchedule() {
      // 去会议议程tab页
      console.log("table", this.meetingBillTable, this.selectedTypes);
      if (!this.meetingBillTable || this.meetingBillTable.length == 0) {
        this.$alert("请选择议题", "提示");
        return;
      }
      this.activeName = "second";
    },
    backtoSchedule() {
      this.activeName = "second";
    },
    gotoBill() {
      this.activeName = "first";
    },
    gotoArrangement() {
      // 去会议安排tab页.去之前要先保存一下设置好的会议议程

      if (!this.basicModel.meetingTopic) {
        this.$alert("请填写会议议题", "提示");
        return;
      }

      if (!this.meetingScheduleTable || this.meetingScheduleTable.length == 0) {
        this.$alert("请创建会议议程", "提示");
        return;
      }
      let noSelect = false;
      this.meetingScheduleTable.forEach((item) => {
        if (!item.selectedTypes || item.selectedTypes.length == 0) {
          noSelect = true;
          return;
        }
      });
      if (noSelect) {
        this.$alert("请为会议议程选择会议类别", "提示");
        return;
      }

      console.log(">>>> 选定议程了\n", this.meetingScheduleTable);

      let params = {};
      params.title = this.basicModel.meetingTopic;
      params.agendaList = [];

      this.meetingScheduleTable.forEach((item) => {
        let vo = {};
        let { bills, selectedTypes } = item;
        let themes = [];
        let ids = [];
        bills.forEach((bill) => {
          themes.push(bill.theme);
          ids.push(bill.id);
        });
        ids.sort(); // 排个序，然后做个id给议程
        item.id = ids.join("_"); // 这时候议程都是纯前端的数据，其实并没有id，为了后面拿回数据后匹配上真实id而这么做
        vo.title = themes.join("\n");
        vo.declarationIdSet = ids;
        vo.typeSet = [];
        selectedTypes.forEach((type) => {
          vo.typeSet.push(type.label);
        });
        params.agendaList.push(vo);
      });

      if (this.meetingScheduleId) {
        params.conferenceId = this.meetingScheduleId;
      }

      console.log(">>>> 整理好数据格式\n", params);
      createConferenceDeclaration(params)
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            console.log(">>>> 回来的数据,会议的id", res.data);
            this.meetingScheduleId = res.data; //就回来个id
            // 这要重新去获取一次详情的数据，才能拿回后台保存的议程的数据，
            // 这样保存会议安排时，才能带上议程的id
            return getConferenceDetail({
              conferenceId: this.meetingScheduleId,
            });
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .then((res) => {
          if (res) {
            if (res.code == Constants.Code_OK) {
              console.log(">>> 建好议程了\n", res.data);
              let { agendaList } = res.data;
              agendaList.forEach((item) => {
                let { id, declarationList } = item; // 这id就是保存到服务器上的议程的id
                let tempIds = [];
                declarationList.forEach((d) => {
                  tempIds.push(d.id);
                });
                tempIds.sort();
                tempIds = tempIds.join("_");
                this.meetingScheduleTable.forEach((o) => {
                  if (o.id == tempIds) {
                    o.id = id;
                  }
                });
              });
              console.log(">>> 修改议程id\n", this.meetingScheduleTable);
            }
          }
        })
        .catch((error) => {
          console.log("error:", error);
        });
      this.activeName = "third";
    },
    selectMeetingBill() {
      // 点击后弹dialog，分页获取提报单列表，从里面选择
      this.meetingBillSelectDialogVisible = true;
    },
    createMeetingSchedule() {
      // 点击生成会议议程
      if (!this.meetingScheduleTable || this.meetingScheduleTable.length == 0) {
        this.meetingScheduleDialogVisible = true;
        return;
      }

      // 已经生成过议程了，再次点击，那就涉及复杂的去重操作。这里就直接提示，已经选好了再点就是需要重新生成
      this.$confirm("再次点击生成议程将清空之前的数据，您确定继续吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.meetingScheduleTable = [];
          this.meetingScheduleDialogVisible = true;
        })
        .catch(() => {});
    },
    submitMeetingBill(data) {
      // dialog中选定了提报单
      console.log("submit meeting bill", data);
      this.meetingBillSelectDialogVisible = false;
      if (data) {
        // 筛选一遍，看看之前有没有已经选过的，去掉重复的
        data.forEach((item) => {
          let index = this.meetingBillTable.findIndex(
            (bill) => bill.id == item.id
          );
          if (index == -1) {
            item.checkWorkList = JSON.parse(item.checkWorkJson);
            // item.cccheckWorkList = JSON.parse(item.ccJoinWorkJson);
            this.meetingBillTable.push(item);
          }
        });
      }
    },
    removeMeetingBill(item) {
      // 从已经选定的提报单列表里删除
      this.$confirm("你确定要删除选中的提报单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then((res) => {
          let index = this.meetingBillTable.findIndex(
            (bill) => bill.id == item.id
          );
          if (index != -1) {
            this.meetingBillTable.splice(index, 1);
          }
        })
        .catch((error) => {});
    },

    isAllChecked(scope, type) {
      console.log("----isAllChecked");
      // 判断全选按钮是否选中了
      return type.allSelectedCheck == true;
    },
    selectAllChangeHandler(scope, type) {
      console.log("---selectAllChangeHandler", type);
      if (!this.meetingScheduleTable || this.meetingScheduleTable.length == 0) {
        // 还没有选定会议议程，这时候全选按钮不让他切换
        return;
      }
      // 类型更改选择标记
      type.allSelectedCheck = !type.allSelectedCheck;
      console.log("--选中状态", type.allSelectedCheck);
      // 这里还要对议程的每一条进行判断。修改他们的类型选定状态

      if (type.allSelectedCheck == false) {
        // 取消全选,找出每个里面，有没有这个类型，有就删掉
        this.meetingScheduleTable.forEach((row) => {
          let { selectedTypes } = row;
          if (selectedTypes && selectedTypes.length) {
            let index = row.selectedTypes.findIndex(
              (item) => item.id == type.id
            );
            if (index != -1) {
              row.selectedTypes.splice(index, 1);
            }
          }
        });
      } else {
        // 选择全选
        this.meetingScheduleTable.forEach((row) => {
          let { selectedTypes } = row;
          if (!selectedTypes) {
            this.$set(row, "selectedTypes", []);
          }
          /**
           * 如果selectedTypes是空，这个type肯定还没有，那就加进去
           * 如果有了selectedTypes
           *    那就看看这个type有没有，
           *        如果没有，就加进去
           *        如果有，那就正好，什么也不需要处理
           */
          if (row.selectedTypes.length == 0) {
            row.selectedTypes.push(type);
          } else {
            let index = row.selectedTypes.findIndex(
              (item) => item.id == type.id
            );
            if (index == -1) {
              row.selectedTypes.push(type);
            }
          }
        });
      }
    },
    checkboxChangeHandler(row, type) {
      // 切换checkbox
      if (!row.selectedTypes) {
        this.$set(row, "selectedTypes", []);
      }
      if (row.selectedTypes.length == 0) {
        row.selectedTypes.push(type);
      } else {
        let index = row.selectedTypes.findIndex((item) => item.id == type.id);
        if (index == -1) {
          row.selectedTypes.push(type);
        } else {
          row.selectedTypes.splice(index, 1);
        }
      }
    },
    isTypeChecked(row, type) {
      let { selectedTypes } = row;
      if (!selectedTypes || selectedTypes.length == 0) {
        return false;
      }
      let index = selectedTypes.findIndex((item) => item.id == type.id);
      return index != -1;
    },
    submitMeetingSchedule(data) {
      this.meetingScheduleDialogVisible = false;
      if (data) {
        this.meetingScheduleTable = data;
        console.log("---data", data);
      }
    },
    removeSchedule(row) {
      this.$confirm("你确定要删除选择的议程吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let index = this.meetingScheduleTable.findIndex(
            (item) => item.id == row.id
          );
          if (index != -1) {
            this.meetingScheduleTable.splice(index, 1);
          }
        })
        .catch((error) => {});
    },
    createArrangement() {
      // 生成会议安排。将上一步选定的议程分类，对应不同的会议类型
      if (!this.meetingScheduleTable || this.meetingScheduleTable.length == 0) {
        this.$alert("请先生成会议议程", "提示");
        return;
      }

      console.log("用来生成会议安排的议程数据\n", this.meetingScheduleTable);

      let arrangeObj = {};
      for (let i = 0; i < this.meetingTypeList.length; i++) {
        let type = this.meetingTypeList[i];
        let arr = arrangeObj[type.label];
        if (!arr) {
          arr = [];
          arrangeObj[type.label] = arr;
        }
        this.meetingScheduleTable.forEach((item) => {
          let index = item.selectedTypes.findIndex(
            (ele) => ele.label == type.label
          );
          if (index != -1) {
            arr.push({
              bills: item.bills,
              id: item.id,
            });
          }
        });
      }

      console.log("生成的会议安排\n", arrangeObj);
      let list = [];
      let count = this.conferenceCount;
      let year = new Date().getFullYear();
      for (let o in arrangeObj) {
        let temp = arrangeObj[o];
        if (temp.length > 0) {
          let item = {
            model: {
              meetingTime: "", //会议时间
              meetingRoom: "", // 会议地点
              meetingTypeLabel: o, //会议类别
              meetingAttendWorkName: "", // 列席人员
              participanceList: [],  //参会人员
              ccParticipanceList: [], //抄送人员
              printTitle: "",
              conferNum: `[${year}]第${++count}次`,
            },
            list: arrangeObj[o],
          };
          if (this.defaultGroupInfo.id) {
            // 默认群组有可能没有
            item.model.participanceList = [
              {
                id: this.defaultGroupInfo.id,
                name: this.defaultGroupInfo.name,
                isDefault: true,
                meetingType: "group",
              },
            ];
          }

          list.push(item);
        }
      }

      console.log("重新处理的会议安排", list);
      // 做一次排序，为了好看
      try {
        list.sort((a, b) => {
          return a.model.meetingTypeLabel.localeCompare(
            b.model.meetingTypeLabel
          );
        });
      } catch (error) {
        console.log(error);
      }

      this.$set(this, "arrangementList", list);

      console.log("111--最终展示会议安排", list);
    },

    /**
     * 保存和暂存都是一个接口，只是状态值不一样
     * @param {*} status 暂存-0  保存-1
     */
    doneArrangement(status) {
      console.log(">>>> 确定了会议安排,要提交了\n", this.arrangementList);
      // arrangementList里，{list , model},list是对应的议程单，model对应其余的form项
      if (!this.basicModel.meetingTopic) {
        // 在生层议程的时候会判断一次，但是生成完之后也有可能改呀，这里要再判断一次
        this.$alert("请填写会议议题", "提示");
        return;
      }

      let tempList = [];

      /**
       * arrangementList里每个数据就是一种类型的会议，比如党代会，董事会
       * 它下面数据{list, model}， model记录了这种类型的会议的时间，地点，类型，参加人员。
       * list是个数组，里面的item是个对象，记录一中类型的会议有多少个议程，有个属性叫bills，是个数组，这是因为
       * 议程可能是多个议题合并而成，所以议程对应的议题是个数组。
       */

      for (let i = 0; i < this.arrangementList.length; i++) {
        let arrange = this.arrangementList[i];
        let { model, list } = arrange;
        let {
          meetingRoom,
          meetingTime,
          meetingTypeLabel,
          participanceList,
          ccParticipanceList,
          printTitle,
          conferNum,
          meetingAttendWorkName,
        } = model;
        if (
          !meetingRoom ||
          !meetingTime ||
          !participanceList ||
          !meetingAttendWorkName||
          participanceList.length == 0
        ) {
          this.$alert("信息填写不完整", "提示");
          return;
        }
        let vo = {};
        tempList.push(vo);
        vo.agendaIdSet = [];
        vo.room = meetingRoom;
        vo.attendWorkName=meetingAttendWorkName;
        vo.startTime = meetingTime.toISOString();
        vo.joinWorkJson = JSON.stringify(participanceList);
        if(ccParticipanceList)
        vo.ccJoinWorkJson = JSON.stringify(ccParticipanceList);
        vo.type = meetingTypeLabel;
        vo.printTitle = printTitle;
        vo.conferNum = conferNum;
        list.forEach((item) => {
          vo.agendaIdSet.push(item.id);
          let titles = [];
          item.bills.forEach((bill) => {
            titles.push(bill.theme);
          });
          vo.title = titles.join("\n");
        });
      }

      let params = {
        conferId: this.meetingScheduleId, // 前一步生成议程时返回的id
        planList: tempList,
        status,
      };
      console.log(">>>> 最后确定的参数\n", params);

      createConferencePlan(params)
        .then((res) => {
          if (res.code == Constants.Code_OK) {
            this.$alert(Constants.Add_OK_Msg, "提示");
            console.log("回来的数据", res.data);
            this.bus.$emit("tabClose", "createGeneralMeeting");
            this.bus.$emit("navMenuChange", {
              routeId: "general-meeting",
            });
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.$alert(error.message || error);
        });
    },

    submitArrangement() {
      this.doneArrangement(1);
    },
    saveArrangement() {
      this.doneArrangement(0);
    },
    getMeetingTypeName(label) {
      // console.log("getMeetingTypeName", label);
      let target = this.meetingTypeList.find((item) => item.label == label);
      if (target) {
        return target.value; // 后台接口label对应的是twh这种标识，value对应的是董事会这种名字。
      }
      return "";
    },
    cancelCreate() {
      this.$confirm("您确定要取消吗？", "提示", {
        confirmButtonText: "确定",
        type: "warning",
      })
        .then(() => {
          this.bus.$emit("tabClose", "createGeneralMeeting");
          this.bus.$emit("navMenuChange", {
            routeId: "general-meeting",
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/commonLayout.scss";
.create-general-meeting {
  background-color: white;
  padding: 20px;
}

.el-tab-pane {
  margin-top: 20px;
}

/deep/ .el-tabs__item {
  padding: 0 20px !important;
}
/deep/ .el-tabs__header {
  padding-right: 0px !important;
}

/deep/ .el-form-item__content {
  display: flex;

  .el-input {
    flex: 1;
  }

  .el-button {
    margin-left: 10px;
    height: fit-content;
  }
}

.tag-wrapper {
  border: 1px solid #dcdfe6;
  padding: 0 5px;
}

.tabs-footer {
  margin-top: 50px;
}

.tabs {
  margin-top: 20px;
}

.tab-wrapper {
  padding: 0 20px;
}

.tab-wrapper-footer {
  text-align: center;
  margin-top: 30px;
}

.checkbox-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  /deep/.el-checkbox {
    margin-right: 0;

    .el-checkbox__label {
      width: 100px;
      box-sizing: border-box;
    }
  }
}

.bill-item {
  padding-top: 6px;
  padding-bottom: 6px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.bill-item + .bill-item {
  border-top: 1px solid #dcdfe6;
}

.my-item {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  /deep/.el-form-item__content {
    margin-left: 0 !important;
  }
}

.arrange-list {
  min-height: 400px;
  margin-top: 10px;
  margin-bottom: 10px;
}

.arrange-item {
  border: 1px solid #dcdfe6;
  padding: 10px;
}

.arrange-item + .arrange-item {
  margin-top: 10px;
}

.divider {
  overflow: hidden;
  text-overflow: ellipsis;
}

.divider + .divider {
  border-top: 1px solid #dcdfe6;
}

/deep/.no-padding-column {
  .cell {
    padding: 0 !important;
  }
}

.quilleditor {
  margin: 0 auto !important;
}
</style>
